import { render, staticRenderFns } from "./BDXEditFormFCPStatus.vue?vue&type=template&id=703a46c8"
import script from "./BDXEditFormFCPStatus.vue?vue&type=script&lang=js"
export * from "./BDXEditFormFCPStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports